module.exports = __webpack_public_path__ + "static/img/bus-lines.9ae7a3da.png";